<template>
  <router-view />
</template>

<script>
export default {
  name: "transceiverassistant",
};
</script>

